var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPc)?_c('PcMain',{attrs:{"language":_vm.language}}):_c('MoMain',{attrs:{"language":_vm.language}})
}
var staticRenderFns = []

export { render, staticRenderFns }